import { bookingsAPI } from 'api/bookingsAPI'
import { useQuery } from '@tanstack/react-query'

export default function useBookingJobs(bookingId: number) {
  const enableQuery = bookingId != null ? true : false
  const query = useQuery({
    queryKey: ['getBookingJobs', bookingId],
    queryFn: async () => bookingsAPI.getBookingJobs(bookingId),
    enabled: enableQuery,
  })

  const response = query.data
  const jobs = response

  return {
    jobs,
    ...query,
  }
}
